export default "__VITE_ASSET__D95e89Bo__"